import { PURGE_CLIENT_TOKENS } from "@onestore/onestore-store-common/api/interceptors"
import domainHookMiddleware from "@gatsby-plugin-basket/middleware/domainHookMiddleware"
import { configureStore, type Middleware } from "@reduxjs/toolkit"
import isServer from "~/lib/isServer"
import { isDebugEnabled } from "~/lib/log"
import { oaoMiddleware } from "~/lib/oao"
import Storage from "~/lib/storage"
import { uwaMiddleware } from "~/lib/uwa"
import analyticsMiddleware from "~/middleware/analyticsMiddleware"
import authMiddleware from "~/middleware/authMiddleware"
import { loadUserDataForToken } from "./basket/actions"
import basketSubscriber from "./basket/subscriber"
import externalAxDomainEventsMiddleware from "./bonus/middleware/externalEvents"
import externalEventsMiddleware from "./checkout/middleware/externalEvents"
import { updateApiVersionFromRequest } from "./core/actions"
import { domainSearchUrlHandler } from "./domain-search/subscriber"
import externalPmailEventsMiddleware from "./pmail/middleware/externalEvents"
import rootReducer from "./reducer"

const middleware: Middleware[] = [
  externalEventsMiddleware,
  externalAxDomainEventsMiddleware,
  externalPmailEventsMiddleware,
  domainHookMiddleware,
  analyticsMiddleware,
  oaoMiddleware,
  uwaMiddleware,
  authMiddleware,
]

export const makeStore = (middleware: Middleware[]) => {
  return configureStore({
    reducer: rootReducer,
    middleware: (getDefaultMiddleware) =>
      getDefaultMiddleware().concat(middleware),
    devTools: isDebugEnabled(),
  })
}

// Infer the type of makeStore
export type RootAppStore = ReturnType<typeof makeStore>
// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootAppState = ReturnType<RootAppStore["getState"]>
export type RootAppDispatch = RootAppStore["dispatch"]

export const store = makeStore(middleware)

store.subscribe(domainSearchUrlHandler(store))

basketSubscriber(store)

if (!isServer()) {
  window.document.addEventListener(
    "api_version_changed",
    (event: CustomEvent) => {
      store.dispatch(updateApiVersionFromRequest(event.detail.version))
    }
  )

  window.document.addEventListener(
    PURGE_CLIENT_TOKENS,
    (_event: CustomEvent) => {
      Storage.clearToken()
      store.dispatch(loadUserDataForToken(null))
    }
  )
}
